import {createFileRoute, useParams} from '@tanstack/react-router';

import SessionSignupPage from '../pages/SessionSignupPage.tsx';
import services from '../services';
import type {RegistrationPage} from '../services';

/**
 * scorepal.co/s/<CODE>: the page a sign-up link opens. The tags WhatsApp reads when the link is
 * posted in a group are put into the served shell by the Worker (server.ts, shareTags.ts): the
 * app is an SPA, so what is here runs in the browser — the loader gives the page its data and
 * the tab its title.
 */
export const Route = createFileRoute('/s/$code')({
    component: RouteComponent,
    loader: async ({params}): Promise<{page: RegistrationPage | null}> => {
        try {
            return {page: await services.clubSessions.publicPage(params.code)};
        } catch {
            return {page: null};
        }
    },
    head: ({loaderData}) => {
        const share = loaderData?.page?.share;
        return {
            meta: [
                {title: `${share?.title ?? 'Sign up on WhatsApp'} | ScorePal`},
                {name: 'description', content: share?.description ?? 'Put your name down for a session in a chat with the ScorePal bot.'},
            ],
        };
    },
});

function RouteComponent() {
    const {code} = useParams({from: '/s/$code'});
    const {page} = Route.useLoaderData();

    return <SessionSignupPage code={code} initial={page}/>;
}
